import { components } from "@certn/api/generated-schemas/client-portal";

type Permission = components["schemas"]["LoggedInUserPermissionsList"];

export const packagePagePermissions = [
  {
    action: "create",
    target: "package",
    scope: "all",
  },
  {
    action: "read",
    target: "packager",
    scope: "all",
  },
  {
    action: "update",
    target: "package",
    scope: "all",
  },
] as unknown as Permission;

export const packageUpdatePermissions = [
  {
    action: "update",
    target: "package",
    scope: "all",
  },
] as unknown as Permission;

export const packageCreatePermissions = [
  {
    action: "create",
    target: "package",
    scope: "all",
  },
] as unknown as Permission;
